import styled from '@emotion/styled';
import css from '@styled-system/css';
import OpenSvg from 'imagesUwKluis/svg/open.svg';
import {string, element, func} from 'prop-types';
import Box from '../../../shared/layouts/Box';
import Flex from '../../../shared/layouts/Flex';
import Stack from '../../../shared/layouts/Stack';
import WithIcon from '../../../shared/layouts/WithIcon';

const QuickActionContainer = styled(Flex)(({ theme }) => ({
  maxWidth: 1024,
  minHeight: 80,
  alignItems: 'center',
  borderRadius: theme.borderRadius,
  boxShadow: theme.boxShadows.normal,
  cursor: 'pointer',
  justifyContent: 'space-between',
}));

const QuickAction = ({ title, message, Icon, action }) => {
  return (
    <QuickActionContainer
      onClick={action}
      bg="primaryBackground"
      px="l"
      py="m"
    >
      <WithIcon space="m" color="primary">
        <Icon width="2rem" height="2rem" />
        <Stack space="xs">
          <Box fontWeight="bold" lineHeight={'1.25rem'}>{title}</Box>
          <Box>{message}</Box>
        </Stack>
      </WithIcon>
      <OpenSvg
        css={css({ fill: 'primary', flexShrink: '0' })}
        width="1.5rem"
        height="1.5rem"
      />
    </QuickActionContainer>
  );
};

QuickAction.propTypes = {
  title: string.isRequired,
  message: string.isRequired,
  Icon: element.isRequired,
  action: func,
};

export default QuickAction;
